module.exports = __webpack_public_path__ + "static/media/cover1-3.48904f70.png";